const LikertScale = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='24' height='24' rx='2' fill='#EDEFF1' />
    <path
      d='M2 21.1055C2 19.7922 2.25866 18.4919 2.7612 17.2786C3.26375 16.0654 4.00035 14.963 4.92893 14.0344C5.85752 13.1058 6.95991 12.3692 8.17317 11.8667C9.38642 11.3641 10.6868 11.1055 12 11.1055C13.3132 11.1055 14.6136 11.3641 15.8268 11.8667C17.0401 12.3692 18.1425 13.1058 19.0711 14.0344C19.9997 14.963 20.7362 16.0654 21.2388 17.2786C21.7413 18.4919 22 19.7923 22 21.1055L12 21.1055L2 21.1055Z'
      fill='#008699'
    />
    <path
      d='M6 21.1055C6 20.3175 6.15519 19.5373 6.45672 18.8094C6.75825 18.0814 7.20021 17.42 7.75736 16.8628C8.31451 16.3057 8.97595 15.8637 9.7039 15.5622C10.4319 15.2607 11.2121 15.1055 12 15.1055C12.7879 15.1055 13.5681 15.2607 14.2961 15.5622C15.0241 15.8637 15.6855 16.3057 16.2426 16.8628C16.7998 17.42 17.2417 18.0814 17.5433 18.8094C17.8448 19.5373 18 20.3175 18 21.1055L12 21.1055L6 21.1055Z'
      fill='#00B3CC'
    />
    <circle cx='12.158' cy='18.1364' r='1.57895' transform='rotate(30 12.158 18.1364)' fill='#E8AF00' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.3135 17.5608L18.1311 7.78951L11.5796 15.9792C12.1587 15.9237 12.718 16.027 13.2094 16.3107C13.7022 16.5952 14.0719 17.0295 14.3135 17.5608Z'
      fill='#E8AF00'
    />
  </svg>
);

export default LikertScale;
